/**
 * `<SlugPreview from={orgName}>` — inline preview of the workspace URL
 * the signup form will produce.
 *
 * Per `aidlc-docs/construction/auth-workspaces-rbac/functional-design/frontend-components.md § <SignupPage>`.
 *
 * Rendered under the org-name field. Hidden when the input is empty or
 * doesn't normalise to a valid slug (e.g., "...!"). The host shown
 * (`app.cometchat-ai.com`) is illustrative; the real product URL is
 * locked in deployment.
 */

import { useTranslation } from "react-i18next";

import { previewSlug } from "../lib/slug-preview";

export interface SlugPreviewProps {
  from: string;
}

export function SlugPreview({ from }: SlugPreviewProps) {
  const { t } = useTranslation("auth");
  const slug = previewSlug(from);
  if (!slug) return null;
  return (
    <p className="mt-1 text-xs text-muted-foreground" data-testid="signup-slug-preview">
      {t("noWorkspace.urlPreviewPrefix")}{" "}
      <span className="font-mono text-foreground">
        app.cometchat-ai.com/w/<strong>{slug}</strong>
      </span>
    </p>
  );
}
